var _rect, _text, _text2, _rect2, _text3, _g, _text4, _rect3, _text5, _g2, _g3, _text6, _g4, _path, _path2, _rect4, _text7, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase3AFig3IndependentDerivation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1100 640",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1100,
    height: 640,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Independent derivation")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "The verifier re-derives the contract from the source; agreement is evidence because it is reached twice")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 110,
    width: 480,
    height: 300,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 150,
    fontSize: 16,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The author sees")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontSize: 14,
    fill: "#1A2F2A"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 186,
    r: 4,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 191
  }, "the full source text"), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 220,
    r: 4,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 225
  }, "and writes the rules, as data"), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 254,
    r: 4,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 259
  }, "30 to 40 verbatim source quotes"), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 288,
    r: 4,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 293
  }, "worked examples, intake, honest scope"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 372,
    fontSize: 12,
    fill: "#6B7F74"
  }, "output: the acceptance contract")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 572,
    y: 110,
    width: 480,
    height: 300,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 604,
    y: 150,
    fontSize: 16,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The verifier sees")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 14,
    fill: "#1A2F2A"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 614,
    cy: 186,
    r: 4,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 191
  }, "the full source text"), /*#__PURE__*/React.createElement("circle", {
    cx: 614,
    cy: 220,
    r: 4,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 225
  }, "field names only: title, lens, intake keys"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontSize: 14,
    fill: "#8A9A90"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 259
  }, "the author's rules"), /*#__PURE__*/React.createElement("line", {
    x1: 630,
    y1: 254,
    x2: 756,
    y2: 254,
    stroke: "#DC2626",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 293
  }, "the author's quotes and examples"), /*#__PURE__*/React.createElement("line", {
    x1: 630,
    y1: 288,
    x2: 866,
    y2: 288,
    stroke: "#DC2626",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 327
  }, "the oracle sketch"), /*#__PURE__*/React.createElement("line", {
    x1: 630,
    y1: 322,
    x2: 750,
    y2: 322,
    stroke: "#DC2626",
    strokeWidth: 1.5
  })))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 604,
    y: 372,
    fontSize: 12,
    fill: "#6B7F74"
  }, "output: an independently derived contract")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#D4DDD6",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288 410 C 288 450, 420 450, 470 470"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812 410 C 812 450, 680 450, 630 470"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M466 462 l12 8 l-14 2 z",
    fill: "#D4DDD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M634 462 l-12 8 l14 2 z",
    fill: "#D4DDD6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 470,
    width: 440,
    height: 130,
    rx: 12,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 504,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Comparison, run by the loop")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 524,
    width: 120,
    height: 52,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 412,
    y: 546,
    fill: "#16A34A",
    textAnchor: "middle",
    fontWeight: 600
  }, "agree"), /*#__PURE__*/React.createElement("text", {
    x: 412,
    y: 563,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "evidence"), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 524,
    width: 120,
    height: 52,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#EAB308",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 546,
    fill: "#1A2F2A",
    textAnchor: "middle",
    fontWeight: 600
  }, "disagree"), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 563,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "a defect signal"), /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 524,
    width: 120,
    height: 52,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#DC2626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 688,
    y: 546,
    fill: "#1A2F2A",
    textAnchor: "middle",
    fontWeight: 600
  }, "cannot derive"), /*#__PURE__*/React.createElement("text", {
    x: 688,
    y: 563,
    fill: "#4A5F56",
    textAnchor: "middle",
    fontSize: 10.5
  }, "not source-grounded"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase3AFig3IndependentDerivation);
export default __webpack_public_path__ + "static/media/case3a-fig3-independent-derivation.0c2ce87b729043fa06f0f7b3db70eede.svg";
export { ForwardRef as ReactComponent };